import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function loadTimeCardEntriesSuccess(timeCardEntries) {
  return { type: types.LOAD_TIME_CARD_ENTRIES_SUCCESS, timeCardEntries };
}

export function createTimeCardEntrySuccess(timeCardEntry) {
  return { type: types.CREATE_TIME_CARD_ENTRY_SUCCESS, timeCardEntry };
}

export function updateTimeCardEntrySuccess(timeCardEntry) {
  return { type: types.UPDATE_TIME_CARD_ENTRY_SUCCESS, timeCardEntry };
}

export function deleteTimeCardEntrySuccess(timeCardEntry) {
  return { type: types.DELETE_TIME_CARD_ENTRY_SUCCESS, timeCardEntry };
}

export function loadTimeCardEntries() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'time-card-entries';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadTimeCardEntriesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function loadTimeCardEntriesByCardId(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'time-cards/' + parseInt(id, 10) + '/time-card-entries';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadTimeCardEntriesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function saveTimeCardEntry(timeCardEntry) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'time-card-entries';
    if (timeCardEntry.id) {
      url = baseApi + 'time-card-entries/' + timeCardEntry.id;
      return axios
        .put(url, {
          ...timeCardEntry,
        })
        .then((response) => {
          dispatch(updateTimeCardEntrySuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    } else {
      return axios
        .post(url, {
          cardId: timeCardEntry.cardId,
          entryDate: timeCardEntry.entryDate,
          entryType: timeCardEntry.entryType,
          timeIn: timeCardEntry.timeIn,
          timeOut: timeCardEntry.timeOut,
          userId: timeCardEntry.userId,
        })
        .then((response) => {
          dispatch(createTimeCardEntrySuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    }
  };
}

export function deleteTimeCardEntry(timeCardEntry) {
  return function (dispatch) {
    let url = baseApi + 'time-card-entries/' + timeCardEntry.id;
    return axios
      .delete(url)
      .then((response) => {
        dispatch(deleteTimeCardEntrySuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/timeCardEntryActions.js